import React, { useState } from 'react';

const SearchOptions = ({ options, onOptionChange }) => {
    const [activeControl, setActiveControl] = useState(null);

    const handleRangeChange = (e) => {
      onOptionChange('maxResults', parseInt(e.target.value));
    };

    return (
      // Removed gradient-bg-blue and hover border color
      <div className="bg-dark-600 rounded-2xl p-6 transition-medium border border-dark-400 hover:shadow-md transform-gpu hover:scale-[1.005]">
        <h3 className="font-bold text-lg mb-4 flex items-center group">
          {/* Using a generic settings icon */}
          <div className="w-8 h-8 rounded-lg bg-accent-blue/20 flex items-center justify-center mr-2 transform-gpu group-hover:rotate-12 transition-medium">
              <i className="fas fa-sliders-h text-accent-blue"></i>
          </div>
          Search Options
          <span className="ml-3 text-xs py-1 px-2 bg-accent-blue/20 rounded-full text-accent-blue opacity-0 group-hover:opacity-100 transition-medium">
            Customize
          </span>
        </h3>
        <div className="space-y-5"> {/* Increased spacing to match ConfigurationPanel */}
          {/* Database Selection */}
          <div
            className="transform-gpu transition-medium hover:scale-[1.02]" // Hover effect on the inner div
            onMouseEnter={() => setActiveControl('database')}
            onMouseLeave={() => setActiveControl(null)}
          >
            <label className="block text-xs text-gray-400 mb-2 group">
                Database Selection
                <span className="ml-2 text-accent-blue opacity-0 group-hover:opacity-100 transition-medium">
                    Filter source data
                </span>
            </label>
            <select
              className={`w-full bg-dark-500 rounded-lg py-2 px-3 text-sm border border-dark-400 focus:outline-none focus:ring-1 focus:ring-accent-blue/50 hover:border-dark-300 transition-medium appearance-none ${
                activeControl === 'database' ? 'ring-1 ring-accent-blue/50' : '' // Subtle active indicator
              }`}
              value={options.database}
              onChange={(e) => onOptionChange('database', e.target.value)}
            >
              <option value="all">All Databases (15.3M accounts)</option>
              <option value="recent">Recent Leaks Only (2.1M accounts)</option>
              <option value="verified">Verified Accounts Only (8.7M accounts)</option>
              <option value="premium" disabled>Premium DB (VIP Only)</option> {/* Keep disabled if logic exists */}
            </select>
          </div>

          {/* Search Type */}
          <div
            className="transform-gpu transition-medium hover:scale-[1.02]"
            onMouseEnter={() => setActiveControl('searchType')}
            onMouseLeave={() => setActiveControl(null)}
          >
            <label className="block text-xs text-gray-400 mb-2 group">
                Search Type
                <span className="ml-2 text-accent-blue opacity-0 group-hover:opacity-100 transition-medium">
                    Username matching
                </span>
            </label>
            {/* Using simple divs for radio buttons */}
            <div className="grid grid-cols-2 gap-2 bg-dark-500 p-1 rounded-lg border border-dark-400">
                 <button
                    onClick={() => onOptionChange('searchType', 'exact')}
                    className={`px-3 py-1.5 rounded-md text-sm transition-medium ${
                        options.searchType === 'exact' ? 'bg-accent-blue text-white shadow-sm' : 'hover:bg-dark-400'
                    }`}
                >
                    Exact Match
                </button>
                 <button
                    onClick={() => onOptionChange('searchType', 'similar')}
                    className={`px-3 py-1.5 rounded-md text-sm transition-medium ${
                        options.searchType === 'similar' ? 'bg-accent-blue text-white shadow-sm' : 'hover:bg-dark-400'
                    }`}
                >
                    Similar Names
                </button>
            </div>
          </div>

          {/* Max Results Range */}
          <div
            className="transform-gpu transition-medium hover:scale-[1.02]"
            onMouseEnter={() => setActiveControl('maxResults')}
            onMouseLeave={() => setActiveControl(null)}
          >
            <label className="block text-xs text-gray-400 mb-2 group">
              Maximum Results
              <span className="ml-2 text-accent-blue opacity-0 group-hover:opacity-100 transition-medium">
                {options.maxResults} results
              </span>
            </label>
            <div className="flex items-center gap-3">
              <input
                type="range"
                min="5" max="50" step="5"
                value={options.maxResults}
                onChange={handleRangeChange}
                className="flex-1 h-2 bg-dark-400 rounded-lg appearance-none cursor-pointer accent-accent-blue hover:h-3 transition-medium disabled:opacity-50 disabled:cursor-not-allowed"
              />
              <span className="text-xs w-10 text-center bg-dark-500 py-1 rounded-lg">
                {options.maxResults}
              </span>
            </div>
            <div className="flex justify-between text-xs mt-1 text-gray-400">
              <span>5</span>
              <span>25</span>
              <span>50</span>
            </div>
          </div>

          {/* Show Confidence Rating */}
          <div
            className="transform-gpu transition-medium hover:scale-[1.02]"
            onMouseEnter={() => setActiveControl('showConfidence')}
            onMouseLeave={() => setActiveControl(null)}
          >
             <label className="flex items-center cursor-pointer group/checkbox">
                <input
                    type="checkbox"
                    id="confidence"
                    className="accent-accent-blue h-4 w-4 border-dark-400 rounded focus:ring-accent-blue/50 transform-gpu hover:scale-110 transition-medium"
                    checked={options.showConfidence}
                    onChange={(e) => onOptionChange('showConfidence', e.target.checked)}
                />
                <span className="ml-2 text-sm text-gray-300 group-hover/checkbox:text-white transition-medium">Show Confidence Rating</span>
            </label>
          </div>
        </div>
      </div>
    );
};

export default SearchOptions;